/* Modules
 ---------------------------------------------------------- */
import Navigation from './modules/_navigation'
import Print from './modules/_print'
import ProductDescriptions from './modules/_product-descriptions'
import WoocommerceScroll from './modules/_woocommerce-scroll'
import AgeCheck from './modules/_agecheck'
import SystemMessage from './modules/_system-message'
import GA4TrackingHandler from './GA4/_ga4-tracking-handler'
import GA4TrackingUpdateCart from './GA4/_ga4-tracking-update-cart'
import CartAutoUpdate from './modules/_cart-auto-update'

/* Run modules
 ---------------------------------------------------------- */
function init () {
  Navigation()
  Print()
  ProductDescriptions()
  WoocommerceScroll()
  AgeCheck()
  SystemMessage()
  GA4TrackingUpdateCart()
  GA4TrackingHandler()
  CartAutoUpdate()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
